const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '牛牛极清模式下支持4K超高清分辨率，每一帧画面都纤毫毕现，色彩饱满细腻，还原影院级视觉享受。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速加载',
    desc: '智能预加载与全球CDN加速技术，点击即播无需等待，牛牛不缓冲引擎确保全程流畅不卡顿。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量片库',
    desc: '收录超10万部高清电影与电视剧全集，涵盖热门新片、经典老剧、冷门佳作，每日持续更新。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '支持手机、平板、电脑全平台无缝切换，观影记录云端同步，随时随地继续追剧不中断。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费安全',
    desc: '全程免费无需注册会员，无隐藏收费、无强制广告，纯净观影环境配合多重安全防护保障。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-3">
          为什么选择牛牛
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          牛牛影视以技术驱动观影体验，五大核心优势为你保驾护航
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-5 md:p-6 text-center group hover:bg-primary-50/30 transition-colors duration-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 md:mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${item.icon} text-xl md:text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}